import * as React from 'react';
import { Modal, Button } from 'antd';
import type { ModalProps } from 'antd';

interface CustomModalProps extends ModalProps {
    title: string; // You can add custom props here
    onConfirm?: () => void; // Custom callback for confirm action
    onCancel?: () => void; // Custom callback for cancel action
    onloading?: boolean; // Custom loading state
}

const CustomModal: React.FC<CustomModalProps> = ({
    title,
    open,
    onConfirm,
    onCancel,
    children,
    onloading,
    ...restProps
}) => {
    return (
        <Modal
            title={title}
            open={open}
            onCancel={onCancel}
            footer={[
                <Button key="cancel" onClick={onCancel}>
                    Cancel
                </Button>,
                <Button key="confirm" loading={onloading} type="primary" onClick={onConfirm}>
                    Confirm
                </Button>,
            ]}
            {...restProps}
        >
            {children}
        </Modal>
    );
};

export default CustomModal;
